import {
  Box,
  Container,
  CssBaseline,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { ArrowRightAlt } from "@mui/icons-material";
import { StyledButton } from "../../../components/common/Button";
import { useNavigate } from "react-router-dom";

const Section = ({
  bgColor,
  title,
  description,
  buttonColor,
  imgSrc,
  link,
}) => {
  const navigate = useNavigate();

  const handleImageClick = (link) => {
    navigate(link);
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <Box sx={{ backgroundColor: bgColor }}>
          <Container sx={{ display: "flex", flexDirection: "column" }}>
            <Box sx={{ marginTop: "2.5rem" }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  fontSize: "1.375rem",
                  color: "#212121",
                  textAlign: "center",
                }}
              >
                {title}
              </Typography>
            </Box>
            <Box sx={{ marginTop: "1.25rem" }}>
              <Typography
                variant="body1"
                sx={{
                  width: "21.875rem",
                  fontSize: "0.8rem",
                  fontWeight: 300,
                  letterSpacing: "0.03em",
                  color: "#374151",
                  textAlign: "center",
                  lineHeight: 1.6,
                }}
              >
                {description}
              </Typography>
            </Box>
            <Box
              sx={{
                marginTop: "1.25rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <StyledButton
                variant="contained"
                width="10.8125rem"
                height="1.5rem"
                style={{
                  backgroundColor: buttonColor,
                  gap: "0.5rem",
                  alignItems: "center",
                  borderRadius: "1.022175rem",
                }}
                onClick={() => handleImageClick(link)}
              >
                <Typography
                  sx={{
                    fontSize: "0.5rem",
                    fontWeight: 700,
                  }}
                >
                  KNOW MORE
                </Typography>

                <ArrowRightAlt
                  sx={{
                    height: "0.75rem",
                    width: "0.75rem",
                  }}
                />
              </StyledButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "1.25rem",
                marginBottom: "2.5rem",
              }}
            >
              <img
                src={imgSrc}
                alt=""
                style={{
                  height: "9.25rem",
                  width: "10.375rem",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Container>
        </Box>
      ) : (
        <Box sx={{ backgroundColor: bgColor }}>
          {title === "Ledger" || title === "Bite" ? (
            <Container sx={{ display: "flex" }}>
              <Box
                sx={{ display: "flex", flex: "1.5", flexDirection: "column" }}
              >
                <Box sx={{ marginTop: "7.5rem" }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 700,
                      fontSize: "2.75rem",
                      color: "#212121",
                    }}
                  >
                    {title}
                  </Typography>
                </Box>
                <Box sx={{ marginTop: "3.75rem" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "26.5rem",
                      fontSize: "1.2rem",
                      fontWeight: 300,
                      letterSpacing: "0.03em",
                      color: "#374151",
                      lineHeight: 1.7,
                    }}
                  >
                    {description}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    marginTop: "4.6875rem",
                    marginBottom: "11.625rem",
                  }}
                >
                  <StyledButton
                    variant="contained"
                    width="15.5rem"
                    height="3rem"
                    style={{
                      backgroundColor: buttonColor,
                      gap: "0.895625rem",
                    }}
                    onClick={() => handleImageClick(link)}
                  >
                    KNOW MORE
                    <ArrowRightAlt
                      sx={{
                        height: "1.25rem",
                        width: "1.25rem",
                      }}
                    />
                  </StyledButton>
                </Box>
              </Box>
              <Box sx={{ display: "flex", flex: "1" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "7.5rem",
                    height: "23.625rem",
                    width: "26.5rem",
                  }}
                >
                  <img src={imgSrc} alt="" />
                </Box>
              </Box>
            </Container>
          ) : (
            <Container sx={{ display: "flex" }}>
              <Box sx={{ display: "flex", flex: "1.5" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "7.5rem",
                    height: "23.625rem",
                    width: "26.5rem",
                  }}
                >
                  <img src={imgSrc} alt="" />
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flex: "1",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Box sx={{ marginTop: "7.5rem" }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 700,
                      fontSize: "2.75rem",
                      color: "#212121",
                    }}
                  >
                    {title}
                  </Typography>
                </Box>
                <Box sx={{ marginTop: "3.75rem" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      width: "26.5rem",
                      fontSize: "1.2rem",
                      fontWeight: 300,
                      letterSpacing: "0.03em",
                      color: "#374151",
                      lineHeight: 1.7,
                    }}
                  >
                    {description}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    marginTop: "4.6875rem",
                    marginBottom: "11.625rem",
                  }}
                >
                  <StyledButton
                    variant="contained"
                    width="15.5rem"
                    height="3rem"
                    style={{
                      backgroundColor: buttonColor,
                      gap: "0.895625rem",
                    }}
                    onClick={() => handleImageClick(link)}
                  >
                    KNOW MORE
                    <ArrowRightAlt
                      sx={{
                        height: "1.25rem",
                        width: "1.25rem",
                      }}
                    />
                  </StyledButton>
                </Box>
              </Box>
            </Container>
          )}
        </Box>
      )}
    </ThemeProvider>
  );
};

export default Section;
